export * from './src/useExternalAuthId';
